<template lang="pug">
div
    el-row(justify="end", type="flex")
        el-col(:span='12')
            el-button(@click="handleSubmit", type='primary', size="small", style="float:right; margin-bottom: 15px", :disabled="$apollo.loading") Submit for Review
    el-card(v-loading="$apollo.loading")
        el-tree(ref="scopeTree", empty-text="loading...", :data='formattedScopes', node-key="id", :check-strictly="true", @check-change="handleCheckbox", :check-on-click-node="false", :expand-on-click-node="false", default-expand-all, show-checkbox)
            span.custom-tree-node(slot-scope='{ node, data }')
                div
                    el-tooltip.item(effect='dark' :content="data.description", placement='top')
                        span {{ data.nice_name }}
                div(v-if="(!data.children || !data.children.length) && node.checked")
                    el-button(type='text', size='mini', class="scope-color" :class="[{ scopeactive: optionalStates[data.id] }]", @click='() => scopeOptionalUpdate(node, data, true)')
                        | optional
                    el-button(type='text', size='mini', class="scope-color" :class="[{ scopeactive: !optionalStates[data.id] }]", @click='() => scopeOptionalUpdate(node, data, false)')
                        | required
    el-row(justify="end", type="flex")
        el-col(:span='12')
            el-button(@click="handleSubmit", type='primary', size="small", style="float:right", :disabled="$apollo.loading") Submit for Review
</template>

<script>
export default {
	name: "ScopeTree",
	props: {
		companyId: {
			type: String,
			required: true
		},
		Scopes: {
			type: Array,
			required: true
		},
		optionalStates: {
			type: Object,
			default: () => {}
		},
		activeScopeIds: {
			type: Array,
			default: () => []
		}
	},
	mounted() {
		this.$refs.scopeTree.setCheckedKeys(this.activeScopeIds);
	},
	computed: {
		formattedScopes() {
			return this.Scopes.filter(scope => !scope.parent_id).map(scope => {
				return {
					...scope,
					children: this.Scopes.filter(s => s.parent_id == scope.id)
				};
			});
		}
	},
	methods: {
		async handleSubmit() {
			const checkedParentsWithoutCheckedChildren = this.$refs.scopeTree.getCheckedNodes().filter((node, i, checkedNodes) => {
				return node.children && node.children.length ? !node.children.filter(child => checkedNodes.find(n => n.id == child.id)).length : false;
			});

			if (checkedParentsWithoutCheckedChildren.length) {
				return this.$message.error(
					`The following parent scopes are selected without any selected child scopes: ${checkedParentsWithoutCheckedChildren.map(c => c.nice_name).join(", ")}`
				);
			}

			this.$emit("submit", this.$refs.scopeTree.getCheckedNodes());
		},
		handleCheckbox(node, checked) {
			if (node.parent_id) {
				this.updateParentScopeNecessity(this.$refs.scopeTree.getNode(node.parent_id));
			}

			if (!checked && node.children) {
				this.uncheckChildren(node);
			}

			if (checked && node.parent_id) {
				this.checkParent(node);
			}
		},
		uncheckChildren(node) {
			this.$refs.scopeTree.setCheckedKeys(this.$refs.scopeTree.getCheckedKeys().filter(ck => !node.children.map(c => c.id).includes(ck)));
		},
		checkParent(node) {
			const checked = this.$refs.scopeTree.getCheckedKeys();
			checked.push(node.parent_id);

			this.$refs.scopeTree.setCheckedKeys(checked);
		},
		scopeOptionalUpdate(node, scope, optional) {
			this.$emit("scope-optional", { scope, optional });

			if (node.parent) {
				this.updateParentScopeNecessity(node.parent);
			}
		},
		updateParentScopeNecessity(node) {
			const allChildrenAreOptional = node.childNodes
				.filter(cn => cn.checked)
				.map(cn => cn.data.id)
				.every(id => this.optionalStates[id] == true);

			this.$emit("scope-optional", { scope: node.data, optional: allChildrenAreOptional });
		}
	}
};
</script>

<style>
.custom-tree-node {
	flex: 1;
	display: flex;
	align-items: center;
	justify-content: space-between;
	font-size: 14px;
	padding-right: 8px;
}
.scope-color {
	font-weight: 300;
	color: darkgrey !important;
}
.scopeactive,
.scopeactive:focus,
.scopeactive:active {
	font-weight: 600;
	color: #4c85ff !important;
}
</style>
